import { useState } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { motion } from 'framer-motion';
import { Copy, Check } from 'lucide-react';
import { Typography } from '@mui/material';

const iconStyle = {
  height: 16,
  width: 16,
};

const CopyableField = ({ label, value, delay = 0 }) => {
  const [copied, setCopied] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {}
  };

  const handleToggleVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5 }}
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4, textAlign: 'left' }}>{label}</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          value={value}
          readOnly
          type={showPassword ? 'text' : 'password'}
          style={{
            background: '#F7F7F7',
            fontSize: 16,
            border: '1px solid #E0E0E0',
            borderRadius: '8px 0 0 8px',
            padding: '8px 12px',
            flex: 1,
            outline: 'none',
            color: '#333',
            borderRight: 'none',
            cursor: 'pointer',
            height: 40,
            boxSizing: 'border-box',
          }}
          onClick={handleCopy}
        />
        <button
          type="button"
          onClick={handleToggleVisibility}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
          style={{
            background: '#F7F7F7',
            border: '1px solid #E0E0E0',
            borderLeft: 'none',
            borderRadius: 0,
            height: 40,
            minWidth: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: 'none',
            boxSizing: 'border-box',
          }}
        >
          {showPassword ? (
            <VisibilityOff style={{ fontSize: 20, color: '#666' }} />
          ) : (
            <Visibility style={{ fontSize: 20, color: '#666' }} />
          )}
        </button>
        <button
          type="button"
          onClick={handleCopy}
          aria-label="Copy to clipboard"
          style={{
            background: '#F7F7F7',
            border: '1px solid #E0E0E0',
            borderLeft: 'none',
            borderRadius: '0 8px 8px 0',
            height: 40,
            minWidth: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: 'none',
            boxSizing: 'border-box',
          }}
        >
          {copied ? (
            <Check style={{ ...iconStyle, color: '#41B568' }} />
          ) : (
            <Copy style={{ ...iconStyle, color: '#666' }} />
          )}
        </button>
      </div>
    </motion.div>
  );
};

export default CopyableField;
